<template>
	<common-layout class="system-notice">
		<div slot="header">
			<h3>首页系统公告</h3>
		</div>
		<div slot="container">
			首页系统公告内容
		</div>
	</common-layout>
</template>

<script>
import CommonLayout from '../../components/common-layout.vue'
export default {
   components: { CommonLayout},
  data() {
    return {};
  },
};
</script>
<style lang="scss">
  @include component(system-notice){
	height: 100%;
  }
</style>



